import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FadeInOutAnimation } from 'src/app/rek-client-app/shared/animations/fade-in-out.animation';
import { DynamicComponent } from '../../modules/dynamic-components/dynamic-component.model';
import { Accordion } from './accordion/accordion.model';
import { AccordionType } from './models/accordion-type.model';
import { AccordionsGroupData } from './models/accordions-group-data.model';

@Component({
  selector: 'rek-accordions-group',
  templateUrl: './accordions-group.component.html',
  styleUrls: ['./accordions-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [FadeInOutAnimation(0.5)]
})
export class AccordionsGroupComponent implements OnInit, DynamicComponent {
  readonly AccordionType: typeof AccordionType = AccordionType;

  accordionsGroupClasses: string;

  @Input() readonly inputData: AccordionsGroupData;
  @Input() accordionsGroupData: AccordionsGroupData;

  constructor() { }

  ngOnInit() {
    if (!this.accordionsGroupData) {
      this.accordionsGroupData = this.inputData;
    }

    if (!this.accordionsGroupData || !this.accordionsGroupData.options || !this.accordionsGroupData.options.accordionType) {
      throw new Error('Accordion options and accordion type must be supplied');
    }

    this.initCssClasses();
  }


  onToggleAccordionItem(accordionItem: Accordion): void {
    this.accordionsGroupData.accordionItems.forEach(s => {
      // if it is the clicked item then toggle it, else collapse it
      s.isOpen = s === accordionItem ? !s.isOpen : false;
    });
  }


  private initCssClasses(): void {
    switch (+this.accordionsGroupData.options.accordionType) {
      case AccordionType.CLASSIC:
        this.accordionsGroupClasses = 'accordion-toggle-arrow';
        break;
      case AccordionType.BORDERLESS_ON_BACKGROUND:
        this.accordionsGroupClasses = 'accordion-light accordion-svg-icon';
        break;
      case AccordionType.STANDALONE:
        this.accordionsGroupClasses = 'accordion-solid accordion-panel accordion-toggle-svg';
        break;
      default:
        throw new Error('Not supported accordion type');
    }
  }
}
